export const EVLOAD_ACTIONS_TYPES = {
  REFRESH_EV_LOAD : "REFRESH_EV_LOAD",
}

export const EVLOAD_ACTIONS = {
  REFRESH_EV_LOAD : (refreshLoad ?: boolean) => {
    return {
      type : EVLOAD_ACTIONS_TYPES.REFRESH_EV_LOAD,
      payload : refreshLoad
    }
  }
}